import axios from 'axios';
import { req } from './axiosFun';

// 定义通用api前缀
//其知网后台接口url前缀(本地)
// var webRoot = 'http://192.168.2.134/index.php';
// 其知网后台后台接口url前缀(线上)
var webRoot = 'https://zlbb.qzhip.com/index.php';


/**
 * 其知网API
 **/

 // 其知网-文章管理
 export const webNewsList = (params) => { return req("post",  "/admin/news/newsList", params) };
 // 其知网-文章管理-发布/编辑文章
 export const webEditNews = (params) => { return req("post",  "/admin/news/editNews", params) };
 // 其知网-文章管理-删除文章-单个
 export const webDelNews = (params) => { return req("post",  "/admin/news/delNews", params) };
 // 其知网-文章管理-删除文章-批量
 export const webDelAllNews = (params) => { return req("post",  "/admin/news/delAllNews", params) };

 // 其知网-问题与建议
 export const webProblemList = (params) => { return req("post",  "/admin/news/problemList", params) };
 // 其知网-问题与建议-删除
 export const webDelProblem = (params) => { return req("post",  "/admin/news/delProblem", params) };
 // 其知网-问题与建议-批量删除
 export const webDelAllProblem = (params) => { return req("post",  "/admin/news/delAllProblem", params) };
 // 其知网-问题与建议-编辑
 export const webEditProblem = (params) => { return req("post",  "/admin/news/editProblem", params) };

 // 其知网-用户管理
 export const webUserList = (params) => { return req("post",  "/admin/users/userList", params) };
 // 其知网-用户管理-发送通知(单发)
 export const webSendUser = (params) => { return req("post",  "/admin/users/sendUserMsg", params) };
 // 其知网-用户管理-发送通知(群发)
  export const webSendUserCheck = (params) => { return req("post",  "/admin/users/sendAllUserMsg", params) };
 // 其知网-用户管理-商务设置
  export const webSetUserSeller = (params) => { return req("post",  "/admin/users/setUserSeller", params) };
 // 其知网-用户管理-提醒设置
  export const webSetUserRemind = (params) => { return req("post",  "/admin/users/setUserRemind", params) };
 // 其知网-用户管理-商务设置
 export const webDownloadUserExcel = (params) => { return req("post",  "/admin/users/downloadExcel", params) };
 // 其知网-用户管理-商务设置
 export const setUserAuth = (params) => { return req("post",  "/admin/users/setUserAuth", params) };
  // 其知网-用户管理-推广管理员列表
  export const getAdminData = (params) => { return req("post",  "/admin/users/getAdminData", params) };
 // 其知网-用户管理-推广记录
 export const webUserInviteList = (params) => { return req("post",  "/admin/users/getInviteLog", params) };

 // 其知网-推广管理
 export const webInviteList = (params) => { return req("post",  "/admin/users/inviteList", params) };
 // 其知网-推广管理-导出推广记录
 export const webExportInviteLog = (params) => { return req("post",  "/admin/users/exportInviteLog", params) };
 // 其知网-推广管理-查询商务推广数据
 export const getSellerInviteList = (params) => { return req("post",  "/admin/users/getSellerInviteList", params) };
 // 其知网-推广管理-查询商务推广年费订单数据
 export const getFeeInviteOrderList = (params) => { return req("post",  "/admin/users/getFeeInviteOrderList", params) };
 // 其知网-推广管理-导出商务推广数据
 export const exportSellerInvite = (params) => { return req("post",  "/admin/users/exportSellerInvite", params) };
 // 其知网-推广管理-导出商务推广年费订单数据
 export const exportFeeInviteOrder = (params) => { return req("post",  "/admin/users/exportFeeInviteOrder", params) };


 // 其知网-分类管理
 export const webCategoryList = (params) => { return req("post",  "/admin/category/categoryList", params) };
 // 其知网-分类管理-编辑
 export const webEditCategory = (params) => { return req("post",  "/admin/category/editCategory", params) };
 // 其知网-分类管理-删除
 export const webDelCategory = (params) => { return req("post",  "/admin/category/delCategory", params) };
 // 其知网-分类管理-获取代理人行业分类
 export const webGetCategory = (params) => { return req("post",  "/admin/category/getCategory", params) };
 // 其知网-代理人管理
 export const webAgentList = (params) => { return req("post",  "/admin/agent/agentList", params) };
 // 其知网-代理人管理-编辑
 export const webEditAgent = (params) => { return req("post",  "/admin/agent/editAgent", params) };
 // 其知网-代理人管理-删除(单个)
 export const webDelAgent = (params) => { return req("post",  "/admin/agent/delAgent", params) };
 // 其知网-代理人管理-获取代理人行业分类(废)
 export const webAgentCate = (params) => { return req("post",  "/admin/agent/getAgentCate", params) };
 // 其知网-代理人管理-获取代理人专业分类
 export const webAgentMajor= (params) => { return req("post",  "/admin/category/getMajor", params) };


 // 其知网-其知学院
 export const webCollegeList = (params) => { return req("post",  "/admin/college/collegeList", params) };
 // 其知网-其知学院-编辑
 export const webEditCollege = (params) => { return req("post",  "/admin/college/editCollege", params) };
 // 其知网-其知学院-删除
 export const webDelCollege = (params) => { return req("post",  "/admin/college/delCollege", params) };
 // 其知网-其知学院-分类
 export const webCateList = (params) => { return req("post",  "/admin/category/getCateList", params) };
// 其知网-其知学院-删除(选中批量)
 export const webDelCheckCollege = (params) => { return req("post",  "/admin/college/delCheckCollege", params) };

 // 其知网-轮播图管理
 export const webBannerList = (params) => { return req("post",  "/admin/banner/getBannerList", params) };
 // 其知网-轮播图管理-编辑
 export const webEditBanner = (params) => { return req("post",  "/admin/banner/editBanner", params) };
 // 其知网-轮播图管理-删除
 export const webDelBanner = (params) => { return req("post",  "/admin/banner/delBanner", params) };
 // 其知网-轮播图管理-获取专利代理模块代理人列表
 export const webBannerAgent = (params) => { return req("post",  "/admin/banner/getBannerAgent", params) };
 // 其知网-轮播图管理-获取其知学院模块文章列表
 export const webBannerCollege = (params) => { return req("post",  "/admin/banner/getBannerCollege", params) };

 // 其知网-API日志管理
 export const webApiList = (params) => { return req("post",  "/admin/users/userApiList", params) };
 // 其知网-API日志管理-删除日志(单个)
 export const webDelApi = (params) => { return req("post",  "/admin/users/delUserApi", params) };
 // 其知网-API日志管理-删除日志(选中)
 export const webDelCheckApi = (params) => { return req("post",  "/admin/users/delCheckUserApi", params) };
 // 其知网-API日志管理-日志导出(选中)
 export const webExportCheckApi = (params) => { return req("post",  "/admin/users/exportCheckUserApi", params) };

 // 其知网-专利市场-出售管理
 export const webMarketSaleList = (params) => { return req("post",  "/admin/market/getSaleList", params) };
 // 其知网-专利市场-出售管理-获取行业分类
 export const webMarketSaleCateList = (params) => { return req("post",  "/admin/market/getCategoryList", params) };
 // 其知网-专利市场-出售管理-审核单个
 export const webMarketVerifySale = (params) => { return req("post",  "/admin/market/verifySale", params) };
 // 其知网-专利市场-出售管理-审核选中
 export const webMarketVerifyCheckSale = (params) => { return req("post",  "/admin/market/verifyCheckSale", params) };
 // 其知网-专利市场-出售管理-设置行业
 export const webMarketSetCateSale = (params) => { return req("post",  "/admin/market/setCateSale", params) };
 // 其知网-专利市场-出售管理-设置选中行业
 export const webMarketSetCateCheckSale = (params) => { return req("post",  "/admin/market/setCateCheckSale", params) };
// 其知网-专利市场-出售管理-添加出售专利
export const webMarketAddSale = (params) => { return req("post",  "/admin/market/addSale", params) };
// 其知网-专利市场-出售管理-删除单个出售专利
export const webMarketDelSale = (params) => { return req("post",  "/admin/market/delSale", params) };
// 专利卫士-专利市场-添加专利
export const webMarketAddMarket = (params) => { return req("post",  "/admin/market/editMarket", params) };
// 专利卫士-专利市场-删除专利
export const webMarketDelMarket = (params) => { return req("post",  "/admin/market/delMarket", params) };
// 其知网-专利市场-出售管理-删除选中出售专利
export const webMarketDelCheckSale = (params) => { return req("post",  "/admin/market/delCheckSale", params) };
// 其知网-专利市场-出售管理-专利修改
export const webMarketEditSale = (params) => { return req("post",  "/admin/market/editSale", params) };

// 其知网-专利市场-求购管理
export const webMarketBuyList = (params) => { return req("post",  "/admin/market/getMarketBuyList", params) };
// 其知网-专利市场-求购管理-审核求购(单条)
export const webMarketVerifyBuy = (params) => { return req("post",  "/admin/market/verifyBuy", params) };
// 其知网-专利市场-求购管理-审核求购(选中)
export const webMarketVerifyCheckBuy = (params) => { return req("post",  "/admin/market/verifyCheckBuy", params) };
// 其知网-专利市场-求购管理-删除求购(单条)
export const webMarketDelBuy = (params) => { return req("post",  "/admin/market/delBuy", params) };
// 其知网-专利市场-求购管理-删除求购(选中)
export const webMarketDelCheckBuy = (params) => { return req("post",  "/admin/market/delCheckBuy", params) };



// 其知网-专利市场-模板管理
export const webMarketExcelList = (params) => { return req("post",  "/admin/excel/getExcelTemplateList", params) };
// 其知网-专利市场-模板管理-添加模板
export const webMarketAddExcel = (params) => { return req("post",  "/admin/excel/addExcelTem", params) };
// 其知网-专利市场-模板管理-编辑模板
export const webMarketEditExcel = (params) => { return req("post",  "/admin/excel/editExcelTem", params) };
// 其知网-专利市场-模板管理-删除模板
export const webMarketDelExcel = (params) => { return req("post",  "/admin/excel/delExcelTem", params) };
// 其知网-专利市场-模板管理-下载出售模板
export const webUploadMarketSaleExcel = (params) => { return req("post",  "/admin/market/downloadMarketSaleExcel", params) };

// 其知网-专利市场-收藏管理
// 其知网-专利市场-收藏管理列表
export const webMarketSaleFavList = (params) => { return req("post",  "/admin/collection/getCollectionList", params) };
// 其知网-专利市场-收藏管理-导出勾选的数据
export const webExportCheckCollection = (params) => { return req("post",  "/admin/collection/exportCheckCollection", params) };
// 其知网-专利市场-收藏管理-导出满足条件的数据
export const webExportAllCollection = (params) => { return req("post",  "/admin/collection/exportAllCollection", params) };

 // 专利市场-列表
 export const webMarketPageList = (params) => { return req("post",  "/admin/market/getMarketPageList", params) };


// 其知网-监控提醒
export const webPatMonList = (params) => { return req("post",  "/admin/monitor/getMonRemindList", params) };
// 其知网-监控提醒-发送提醒
export const webSendRemind = (params) => { return req("post",  "/admin/monitor/sendMonRemind", params) };
// 其知网-监控提醒-导出勾选中的监控数据
export const webCheckExportMonitor = (params) => { return req("post",  "/admin/monitor/checkExportMonitor", params) };
// 其知网-监控提醒-导出所有满足条件的监控数据
export const webExportMonitorAll = (params) => { return req("post",  "/admin/monitor/exportMonitorAll", params) };

// 其知网-缴费管理
// 其知网-缴费管理-缴费列表
export const webOrderList = (params) => { return req("post",  "/admin/order/orderList", params) };
// 其知网-缴费管理-处理缴费
export const webHandleFee = (params) => { return req("post",  "/admin/order/changeIsEnable", params) };
// 其知网-缴费管理-导出选中的年费订单
export const webExportCheckOrder = (params) => { return req("post",  "/admin/order/exportCheckOrder", params) };
// 其知网-缴费管理-导出所有满足条件的年费订单
export const webExportAllOrder = (params) => { return req("post",  "/admin/order/exportAllOrder", params) };

// 其知创新
// 新闻管理-新闻列表
export const officeNewsList = (params) => { return req("post",  "/admin/article/getArticleList", params) };
// 新闻管理-编辑
export const officeNewsEdit = (params) => { return req("post",  "/admin/article/editArticle", params) };
// 新闻管理-预览
export const officeNewsView = (params) => { return req("post",  "/admin/article/viewArticle", params) };
// 新闻管理-删除
export const officeNewsDel = (params) => { return req("post",  "/admin/article/delArticle", params) };
// 新闻管理-删除勾选
export const officeNewsDelCheck = (params) => { return req("post",  "/admin/article/delCheckArticle", params) };

// 专利管理
// 监控提醒
export const webPatList = (params) => { return req("post",  "/admin/monitor/getRemindList", params) };
// 新增监控
export const webPatNewList = (params) => { return req("post",  "/admin/monitor/getNewRemindList", params) };

// 年费查询
export const webPatFeeQuery = (params) => { return req("post",  "/admin/monitor/getPatFeeQuery", params) };
// 年费查询-更新时间（单个）
export const webPatFeeUpdDate = (params) => { return req("post",  "/admin/monitor/updPatDate", params) };
// 年费查询-更新年费（单个）
export const webPatUpdOneFee = (params) => { return req("post",  "/admin/monitor/updOneAnnualFee", params) };
// 年费管理
export const webPatFeeList = (params) => { return req("post",  "/admin/monitor/getPatFeeList", params) };
// 年费管理-更新专利状态
export const webUpdPatStatus = (params) => { return req("post",  "/admin/monitor/editPatFeeStatus", params) };
// 专利管理-监控提醒-监控导入模板下载
export const webDownloadPatMonExcel = (params) => { return req("post",  "/admin/monitor/downloadPatMonExcel", params) };
// 专利管理-监控提醒-删除专利
export const delRemindTrial = (params) => { return req("post",  "/admin/monitor/delRemindTrial", params) };


// 申请号管理
// 申请号管理-列表
export const webPatApplyNumList = (params) => { return req("post",  "/admin/monitor/getPatApplyNumList", params) };
// 申请号管理-删除(单个)
export const webPatApplyNumDel = (params) => { return req("post",  "/admin/monitor/delPatApplyNum", params) };
// 申请号管理-删除(勾选)
export const webPatApplyNumDelCheck = (params) => { return req("post",  "/admin/monitor/delPatApplyNumCheck", params) };
// 申请号管理-添加
export const webEditPatApplyNum = (params) => { return req("post",  "/admin/monitor/editPatApplyNum", params) };

// 审中专利管理
// 审中专利管理-列表
export const webPatTrialList = (params) => { return req("post",  "/admin/monitor/getRemindTrialList", params) };
// 审中专利管理-导出勾选的数据
export const webCheckTrialExportMonitor = (params) => { return req("post",  "/admin/monitor/exportCheckRemindTrial", params) };
// 审中专利管理-导出满足搜索条件的数据
export const webSearchTrialExportMonitor = (params) => { return req("post",  "/admin/monitor/exportSearchRemindTrial", params) };
// 审中专利管理-录入专利审查中进度信息
export const webUpdateTrialPat = (params) => { return req("post",  "/admin/monitor/updateTrialPat", params) };
// 审中专利管理-删除审中专利(单个)
export const webDelTrialPat = (params) => { return req("post",  "/admin/monitor/delRemindTrial", params) };
// 审中专利管理-删除审中专利(勾选)
export const webDelTrialPatCheck = (params) => { return req("post",  "/admin/monitor/delRemindTrialCheck", params) };

 // 其说论坛
 // 其说论坛-帖子列表
 export const webPlatformList = (params) => { return req("post",  "/admin/platform/getArticlePageList", params) };
 // 其说论坛-删除帖子(单个)
 export const webDelPlatform = (params) => { return req("post",  "/admin/platform/delArticle", params) };
 // 其说论坛-删除帖子(批量)
 export const webDelCheckPlatform = (params) => { return req("post",  "/admin/platform/delCheckArticle", params) };
 // 其说论坛-审核帖子(单个)
 export const webEditPlatform = (params) => { return req("post",  "/admin/platform/editArticle", params) };
 // 其说论坛-审核帖子(批量)
 export const webEditCheckPlatform = (params) => { return req("post",  "/admin/platform/editCheckArticle", params) };
 // 其说论坛-论坛文章模块
 export const webPlatformCategory = (params) => { return req("post",  "/admin/platform/getPlatformCategory", params) };

 // 购物卡
 // 购物卡列表
 export const shopCardPageList = (params) => { return req("post",  "/admin/shop/getShopCardList", params) };
 // 添加购物卡(单张)
 export const addShopCard = (params) => { return req("post",  "/admin/shop/addShopCard", params) };
 // 批量导入购物卡(excel)
 export const importShopCard = (params) => { return req("post",  "/admin/shop/importShopCard", params) };
 // 修改购物卡状态
 export const editShopCardStatus = (params) => { return req("post",  "/admin/shop/editShopCardStatus", params) };
 // 用户购物卡列表
 export const userShopCardPageList = (params) => { return req("post",  "/admin/shop/getUserShopCardList", params) };
 // 购物卡过期设置
 export const expiredShopCard = (params) => { return req("post",  "/admin/shop/expiredShopCard", params) };

// 专利爬虫记录
// 专利爬虫记录-列表
export const webPatReptileList = (params) => { return req("post",  "/admin/reptile/getReptilePageList", params) };
// 专利爬虫记录-删除
export const delPatentReptile = (params) => { return req("post",  "/admin/reptile/delReptile", params) };
// 专利爬虫记录-列表(代理机构)
export const webPatReptileAgencyList = (params) => { return req("post",  "/admin/reptile/getReptileAgencyPageList", params) };
// 专利爬虫记录-删除(代理机构)
export const delPatentReptileAgency = (params) => { return req("post",  "/admin/reptile/delReptileAgency", params) };
// 专利爬虫记录-执行爬虫任务
export const runReptileTask = (params) => { return req("post",  "/admin/reptile/runReptileTask", params) };
// 专利爬虫记录-列表(新监控)
export const webPatReptileMonitorList = (params) => { return req("post",  "/admin/reptile/getReptileMonitorPageList", params) };
// 专利爬虫记录-删除(新监控)
export const delPatentReptileMonitor = (params) => { return req("post",  "/admin/reptile/delReptileMonitor", params) };
// 专利爬虫记录-列表(近期待缴)
export const webPatReptileNearList = (params) => { return req("post",  "/admin/reptile/getReptileNearPageList", params) };
// 专利爬虫记录-删除(近期待缴)
export const delPatentReptileNear = (params) => { return req("post",  "/admin/reptile/delReptileNear", params) };

// 专利爬虫记录
// 专利导入爬虫记录-列表
export const webImportbPatReptileList = (params) => { return req("post",  "/admin/reptile/getImportReptilePageList", params) };
// 专利导出爬虫记录
export const webExportbPatReptile = (params) => { return req("post",  "/admin/reptile/exportImportReptile", params) };
// 专利导出爬虫记录
export const webDownloadExcel = (params) => { return req("post",  "/admin/reptile/getImportReptileExcel", params) };
// 删除导入爬虫记录
export const delImportReptile = (params) => { return req("post",  "/admin/reptile/delImportReptile", params) };

// 邮件系统
// 邮箱管理-列表
export const getEmailList = (params) => { return req("post",  "/admin/email/getEmailList", params) };
// 邮箱管理-编辑
export const editEmail = (params) => { return req("post",  "/admin/email/editEmail", params) };
// 邮箱管理-删除
export const delEmail = (params) => { return req("post",  "/admin/email/delEmail", params) };
// 模板管理-列表
export const getTemplateList = (params) => { return req("post",  "/admin/email/getTemplateList", params) };
// 模板管理-编辑
export const editTemplate = (params) => { return req("post",  "/admin/email/editTemplate", params) };
// 模板管理-删除
export const delTemplate = (params) => { return req("post",  "/admin/email/delTemplate", params) };
// 任务管理-列表
export const getTaskList = (params) => { return req("post",  "/admin/email/getTaskList", params) };
// 任务管理-编辑
export const editTask = (params) => { return req("post",  "/admin/email/editTask", params) };
// 任务管理-查询所有邮件模板
export const getTemplate = (params) => { return req("post",  "/admin/email/getTemplate", params) };
// 任务管理-删除
export const delTask = (params) => { return req("post",  "/admin/email/delTask", params) };
// 任务执行管理-列表
export const getExecuteList = (params) => { return req("post",  "/admin/email/getExecuteList", params) };
// 任务执行管理-编辑
export const editExecute = (params) => { return req("post",  "/admin/email/editExecute", params) };
// 任务执行管理-批量导入
export const ImportExecute = (params) => { return req("post",  "/admin/email/ImportExecute", params) };
// 任务管理-查询所有任务
export const getTask = (params) => { return req("post",  "/admin/email/getTask", params) };
// 任务管理-查询所有任务
export const rechargeIntegral = (params) => { return req("post",  "/admin/users/rechargeIntegral", params) };



 //
 export const webUrl = 'https://zlbb.qzhip.com/index.php';
//  export const webUrl = 'https://zlws.qzhip.cn/index.php';
//  export const webUrl = 'http://192.168.2.135/index.php';


// WEBPACK FOOTER //
// ./src/api/webMG.js